var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInStoreSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 416.16 391",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-10,.cls-2{fill:#fff;}.cls-11,.cls-3,.cls-6,.cls-7,.cls-9{fill:none;}.cls-10,.cls-11,.cls-3,.cls-7,.cls-9{stroke:#010101;stroke-linejoin:round;}.cls-10,.cls-11,.cls-3,.cls-6,.cls-7,.cls-9{stroke-linecap:round;}.cls-10,.cls-3,.cls-6{stroke-width:1.01px;}.cls-4{fill:#d0dfe6;}.cls-5{fill:#010101;}.cls-6{stroke:#d0dfe6;stroke-miterlimit:10;}.cls-8{fill:#6bb136;}.cls-9{mix-blend-mode:multiply;}.cls-11{stroke-width:0.83px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M394.56,288.64c-55.54,86-197.39,130.48-292.62,83C45.61,343.58,9.54,265.44,1.37,209.24-11,123.9,61.68,8.17,186,.73s70.26,43.69,113.72,60.36c33.75,13,40,3.18,82.84,37.18S424.92,241.65,394.56,288.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M150.44,298.22s.91,1.12-4.73,1.12a46.65,46.65,0,0,1-6.63-.22c-20,0-29.56-16.05-24.88-38.76,5.49-26.6,27.72-91.52,27.72-91.52"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 161.17,
    y1: 208.71,
    x2: 170.63,
    y2: 176.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.23,158.61c3.74-1.75,7.16-3.16,8.38-4.38,2-2,3.77-6.89-2.51-7s-6.21-.18-6.21-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M195,144.15c-3.3,1-1.89,7.53-2.61,8.68"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "166.24 136.78 164.9 142.34 162.72 143.93"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 168.18,
    y1: 124.75,
    x2: 166.66,
    y2: 130.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 173.02,
    y1: 103.85,
    x2: 169.89,
    y2: 116.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142,170.71s-.92-12.55-1.8-20.79.63-11.22,1.88-14,6.8-5.86,7.67-5.9a25.09,25.09,0,0,1,2-6.62,8.14,8.14,0,0,1,4.16-3.53,12.86,12.86,0,0,1,1.3-5.43,3.58,3.58,0,0,1,1.8-1.26c3.51-1.4,6.77-.25,9.41,2.4a8.91,8.91,0,0,1,2.85,5.34c.23,3.14-2.08,4.63-5.35,2.29-2.39-1.71-1.56-.9-1.56-.9s-5.29-2.5-3.64-.41,5.8,8.52,6.28,11.32c.51,3-.25,4.55-2.51,4.67s-7.65-6.63-7.65-6.63,6.37,9.72,5.91,12.1c-.37,1.87-3.1,2.67-4.8,1.29-1.52-1.24-6.73-6.39-6.73-6.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M154.77,127.71a21.22,21.22,0,0,0,2.57,4.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M152,273c-3.22,28.38-20.34,100.34-20.34,100.34l155.71-.77S299.78,243.43,297,187.72c-1.05-21.48-26.26-36-39.2-40.32-4-1.33-2.52-1.66-5.49-2.23a17.7,17.7,0,0,0-2-.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M173.42,106.56c-2.6-1.32-4.27-6-3.92-8.81a13.3,13.3,0,0,0,.41-3.48c-.22-1.53-1.43-2.71-2.23-4a8.22,8.22,0,0,1-1-5.79c.19-1,.56-1.89.67-2.87.56-4.76-5-9-3.73-13.62.43-1.6,1.61-2.92,2.19-4.47,1.17-3.1-.2-6.51-.33-9.81a13.46,13.46,0,0,1,4.45-10.43c1.36-1.21,3-2.18,4-3.69a15,15,0,0,0,1.53-3.81c2.71-8.16,10.8-14.81,19.55-14.36a38.23,38.23,0,0,0,4.77.26,23.08,23.08,0,0,0,6.2-1.86c8.31-3.11,19-2.84,24.6,3.93,9.38-3,27.73,8.36,30.65,11.33s7.31,15.32,5.88,17.82a13.84,13.84,0,0,1,2.77,17.82,7.94,7.94,0,0,0-1.51,2.85,6.35,6.35,0,0,0,.14,2.21c.94,5.23.9,11.67-3.64,14.55A5.66,5.66,0,0,0,263,91.74c-.53.77-3.67-3.78-6.82-2.88l-7,4.52h0s-2,.3-2.89-.45-.66-4.18,1-5.52-1.27-.14-1.27-.14l-2.29-3V80.7l2.26-3.81-2.1-2L242,73.24l-.61-3,1.75-3.39-4.49-2.43L236.47,60l.74-4-4.85-2.16-2.9-3-1.37-3.13.11-2.62-5.6.38-3.5-.74-3.75-2.83-2.2,3.42-5.64,1.79-5.33-1.34L200,44l-7.11.18-4.24-1.72-3.38,6.64-5.42,3.63.09,2.94-4.27,6.26-3,1.64-.76,4.93-.46,5.22,2,32.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.91,153.61c.26,5.32.56,11.4.56,11.4h0c-1,10,11,16.17,18.85,9.64l29.45-24.48-1.38-36.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M171.28,72.84c.49,16.2,1.74,36,4.83,47.79,6.21,23.8,25.42,25.16,25.42,25.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M201.47,147.34l.06-1.55a63.93,63.93,0,0,0,32.23-11.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.92,88.49c4.78-1.18,9.88-1,11.11,11,1.67,16.46-15.56,14.71-15.64,14.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M253.72,96.55c-.05,0-.39-.24-.33-.93a1.9,1.9,0,0,1,.56-1.1,2.23,2.23,0,0,1,1.58-.57,4.14,4.14,0,0,1,3.32,2.25,9.61,9.61,0,0,1,1.48,4.49c.23,3.33-1.19,6.6-3.55,7.52a3.22,3.22,0,0,1-2.73-.17c-.56-.36-.68-.72-.63-.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M227.49,248.15s62.78,15.24,63,14.89c1-1.37,10.92-49.09,6.51-74.67"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 206.45,
    y1: 115.02,
    x2: 209.93,
    y2: 127.72
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.25,175.19s-8.54,2.39-12.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M160.22,121a5.32,5.32,0,0,0-4.38-1.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M156.77,131.24s-4.44-4.26-7.05-1.24"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 227.49,
    y1: 248.15,
    x2: 236.88,
    y2: 199.81
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 161.17,
    y1: 208.71,
    x2: 155.93,
    y2: 260.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M217.23,106.38c1,4.12,6.36,6.28,12,4.82s9.41-6,8.42-10.12-6.36-6.28-12-4.82S216.24,102.25,217.23,106.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M187.61,78.5l-6.92,1.71c-.78.19-1.61-.53-1.83-1.6h0a1.9,1.9,0,0,1,1-2.31l6.91-1.71c.79-.19,1.61.53,1.83,1.6h0A1.89,1.89,0,0,1,187.61,78.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.83,82.57l-7.58-3A2.06,2.06,0,0,1,203.11,77l.1-.29a1.82,1.82,0,0,1,2.4-1.15l7.57,3a2.06,2.06,0,0,1,1.14,2.56l-.09.29A1.83,1.83,0,0,1,211.83,82.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M205.53,94.62h.12a2.39,2.39,0,0,0,2.26-2.51l-.14-3.68a2.39,2.39,0,0,0-2.44-2.33h-.12A2.39,2.39,0,0,0,203,88.61l.14,3.68A2.39,2.39,0,0,0,205.53,94.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M183.88,93.56H184a2.3,2.3,0,0,0,2.17-2.41L186,87.27A2.29,2.29,0,0,0,183.68,85h-.12a2.29,2.29,0,0,0-2.16,2.41l.14,3.88A2.29,2.29,0,0,0,183.88,93.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M190.36,96.83s-1.47,6.3-2.28,10.12c1.12,2.08,8.28,2.64,8.28,2.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.58,120.32s11.74,2,18-1.46"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 199.87,
    y1: 73.43,
    x2: 189.99,
    y2: 73.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 200.19,
    y1: 67.33,
    x2: 187.34,
    y2: 67.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 337.82,
    y1: 372.52,
    x2: 64.09,
    y2: 372.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M193.23,158.61c0,10.06-7.54,18.52-17.73,18.52s-18.91-6.28-18.91-16.34c0-6.94,2.21-10.6,5.13-15.94"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 177.35,
    cy: 158.61,
    rx: 15.88,
    ry: 15.68
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 177.26,
    cy: 158.62,
    rx: 12.06,
    ry: 11.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 175.5,
    cy: 151.72,
    rx: 0.17,
    ry: 0.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 178.45,
    cy: 154.79,
    rx: 2,
    ry: 1.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 177.15,
    cy: 163.04,
    rx: 2,
    ry: 1.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 172.63,
    cy: 157.76,
    rx: 2,
    ry: 1.96
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 182.71,
    cy: 159.64,
    rx: 2,
    ry: 1.96
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 173.93,
    y1: 118.96,
    x2: 168.19,
    y2: 142.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M121.13,340.46c0,.07-.4,2,1,.91.6-.48-2.68-6-1.87-6.67.64-.53,5.44,3.73,6.19,3.09s-2.85-6-2.13-6.59,5.6,3.51,6.3,2.87-3-5.86-2.35-6.51,5.72,3.33,6.38,2.68-3.19-5.78-2.54-6.44,5.82,3.14,6.47,2.48-3.38-5.68-2.75-6.36,5.93,2.95,6.55,2.26-3.56-5.56-3-6.26,6,2.74,6.62,2-3.76-5.43-3.18-6.15,6.13,2.5,6.69,1.78-4-5.28-3.44-6,6.25,2.22,6.77,1.47-4.22-5.08-3.72-5.84,6.35,1.89,6.83,1.12-4.49-4.84-4-5.63,6.45,1.51,6.88.71-4.8-4.53-4.4-5.35,6.56,1,6.92.21-5.14-4.13-4.8-5,6.62.46,6.91-.4-5.51-3.61-5.27-4.49,6.64-.24,6.83-1.13-5.86-3.1-5.73-4c.37-1.82,6.53,0,7-2.29.23-1-5.71-3.59-5.41-5,.24-1.1,6.72-1,7-2.3.24-1.14-5.74-3.63-5.48-4.91s6.72-1.13,7-2.39-5.78-3.6-5.54-4.85,6.71-1.22,6.94-2.47-5.82-3.54-5.6-4.78,6.69-1.31,6.9-2.55-5.85-3.48-5.65-4.71,6.67-1.42,6.87-2.65-5.91-3.4-5.72-4.63,6.65-1.52,6.83-2.76-6-3.31-5.8-4.54,6.63-1.64,6.78-2.87-6-3.21-5.87-4.43,6.59-1.78,6.72-3-6.08-3.08-6-4.31,6.56-1.93,6.65-3.16-6.15-2.93-6.07-4.15,6.49-2.13,6.55-3.36-6.24-2.72-6.21-3.95,6.42-2.37,6.43-3.59-6.35-2.46-6.37-3.68,6.29-2.7,6.23-3.91-6.48-2.09-6.58-3.29,6.09-3.17,5.93-4.36-6.63-1.49-6.85-2.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M123.69,365.41c0,4.16-2.87,7.53-6.41,7.53H33.36c-3.54,0-6.41-3.37-6.41-7.53v-9c0-4.15,2.87-7.53,6.41-7.53h83.92c3.54,0,6.41,3.38,6.41,7.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.54,348.9H31.83c-3.54,0-6.41,3.38-6.41,7.53v9c0,4.16,2.87,7.53,6.41,7.53h83.92c3.54,0,6.41-3.37,6.41-7.53v-2.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M112.39,291.08a6,6,0,0,0-3.07-5.19H40.37a6,6,0,0,0-2.5,4.83L27,350.39a6.25,6.25,0,0,0,6.41,6.09h83.92a6.25,6.25,0,0,0,6.41-6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62,328a3.2,3.2,0,1,1-3.2-3.21A3.2,3.2,0,0,1,62,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.45,324.88a3,3,0,0,0-.61-.06,3.21,3.21,0,0,0,0,6.41,3.29,3.29,0,0,0,1.5-.37A4.14,4.14,0,0,1,59.45,324.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.32,294.78a24.57,24.57,0,1,0,24.57,24.57A24.57,24.57,0,0,0,75.32,294.78Zm0,38a13.45,13.45,0,1,1,13.45-13.45A13.45,13.45,0,0,1,75.32,332.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96.87,315.48a3.21,3.21,0,1,1-3.2-3.21A3.2,3.2,0,0,1,96.87,315.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M93.92,314.81v-.13a3.84,3.84,0,0,1,.74-2.25,3.26,3.26,0,0,0-1-.16,3.21,3.21,0,1,0,2,5.73A3.9,3.9,0,0,1,93.92,314.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.86,307.33a3.2,3.2,0,1,1-3.2-3.2A3.2,3.2,0,0,1,92.86,307.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M90.28,304.19a3.2,3.2,0,1,0,.88,6A4.12,4.12,0,0,1,90.28,304.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.71,300.92a3.21,3.21,0,1,1-3.2-3.2A3.21,3.21,0,0,1,76.71,300.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M74.12,297.78a3.08,3.08,0,0,0-.61-.06,3.21,3.21,0,1,0,1.49,6A4.13,4.13,0,0,1,74.12,297.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M86.46,301.86a3.21,3.21,0,1,1-3.21-3.21A3.21,3.21,0,0,1,86.46,301.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M83.87,298.71a4.2,4.2,0,0,0-.62-.06,3.21,3.21,0,0,0,0,6.41,3.29,3.29,0,0,0,1.5-.37A4.13,4.13,0,0,1,83.87,298.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M68.45,304.13a3.21,3.21,0,1,1-3.2-3.21A3.2,3.2,0,0,1,68.45,304.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65.86,301a3.08,3.08,0,0,0-.61-.06,3.21,3.21,0,1,0,1.49,6A4.13,4.13,0,0,1,65.86,301Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62,310.53a3.2,3.2,0,1,1-3.2-3.2A3.21,3.21,0,0,1,62,310.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.45,307.39a3,3,0,0,0-.61-.06,3.21,3.21,0,0,0,0,6.41,3.29,3.29,0,0,0,1.5-.37A4.14,4.14,0,0,1,59.45,307.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M59.6,319.35a3.21,3.21,0,1,1-3.21-3.21A3.21,3.21,0,0,1,59.6,319.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M57,316.2a3.11,3.11,0,0,0-.62-.06,3.21,3.21,0,0,0,0,6.41,3.14,3.14,0,0,0,1.5-.37A4.13,4.13,0,0,1,57,316.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62,328a3.2,3.2,0,1,1-3.2-3.21A3.2,3.2,0,0,1,62,328Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M59.45,324.88a3,3,0,0,0-.61-.06,3.21,3.21,0,0,0,0,6.41,3.29,3.29,0,0,0,1.5-.37A4.14,4.14,0,0,1,59.45,324.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M67.6,334.43a3.21,3.21,0,1,1-3.21-3.2A3.21,3.21,0,0,1,67.6,334.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M65,331.29a3.2,3.2,0,1,0-.62,6.35,3.26,3.26,0,0,0,1.5-.37A4.13,4.13,0,0,1,65,331.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M76.71,338.77a3.21,3.21,0,1,1-3.2-3.2A3.21,3.21,0,0,1,76.71,338.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M74.12,335.63a3.08,3.08,0,0,0-.61-.06,3.21,3.21,0,1,0,0,6.41A3.11,3.11,0,0,0,75,341.6,4.12,4.12,0,0,1,74.12,335.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "84.75 331.23 90.46 345.25 98.12 338.24 84.75 331.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M89.79,272.62c1.39,2.93-.85,6.63-.85,6.63H61.71s-2.24-3.7-.86-6.63h-9S50,282.4,54.76,285.89H95.88c4.81-3.49,2.94-13.27,2.94-13.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M98.82,272.62h-4C95,275.1,95,281,92.16,283H58.48c-2.83-2.06-2.83-7.92-2.61-10.4h-4S50,282.4,54.76,285.89H95.88C100.69,282.4,98.82,272.62,98.82,272.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M189.58,120.32l2.64,6.65a7.34,7.34,0,0,0,3.89,3.59,6.88,6.88,0,0,0,8.9-3.36l2.83-5.86"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 31.36,
    y1: 353,
    x2: 116.29,
    y2: 353
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.67,46.27s12.52,18.39,33.73,14.64,9.73,14.52,20.52,17c20.52,4.77,28.87-6.12,28.87-6.12l-23.3-31.32-30.61-10.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M236.53,254.27,224.79,286l-56.34,43.66c-8.85,2.93-18.87,3.11-19.31,2.78,0,0-11.74,6.68-15.2,8.62s-3.53,5-7.4,9.3-23.55,15.3-19.16,21c2.82,3.67,18.13-9.26,22-12.64s9.12-2.19,8.69-1.65-29.2,19-29.2,19-5.79,2.79-4.44,5.58,6.89,2.7,6.89,2.7,3.65,2.59,6.35,2.48c.89-.05,3.72-1.3,7.13-3,7-3.42,16.34-8.58,16.34-8.58s-2.86,6.57-3.84,7.79-7.4,1.54-10.13,1.85a3.17,3.17,0,0,0-1,.26c-1.57.69-1,2.52-.25,4.05.88,1.79,10.46,1.27,13.15.27s20.57-12.89,20.57-12.89a66.35,66.35,0,0,0,9.75-7.24c5.57-5.11,9.22-15.92,9.22-15.92s76-34.1,84.37-45.2,15.39-43.41,16.35-46.54"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 110.34,
    y1: 384.32,
    x2: 140.97,
    y2: 363.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 143.36,
    y1: 353.34,
    x2: 145.74,
    y2: 357.08
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.14,332.46s-14.85,1.81-18.68,6.58-6.61,13.28-6.61,13.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M189.32,116a38.39,38.39,0,0,0-.78,12.51"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "250.44 137.85 212.79 156.83 208.71 175.98"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "203.15 146.02 208.36 155.89 207.84 174.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 208.71,
    y1: 175.98,
    x2: 176.02,
    y2: 324.06
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStoreSupport);
export default __webpack_public_path__ + "static/media/in-store-support.c2dc66c4bac777e54385c1286b86660a.svg";
export { ForwardRef as ReactComponent };